import Promise from 'promise-polyfill';
import { polyfill } from 'es6-promise';
polyfill();
import 'whatwg-fetch';
import fetch from 'isomorphic-fetch';
import { BrandEnvService, DomainCode } from './brand-env.service';

export var BrtService = (function() {
    var permission = false;
    var BRT_KEY = 'BOLD_CHAT';

    function callRogersApi(params) {}

    function callFidoApi() {
        var url = '/pages/api/selfserve/v1/permissions';
        var promise = fetch(url, {
            method: 'POST',
            credentials: 'same-origin'
        })
            .then(function(response) {
                if (response.ok) {
                    return response.json();
                } else {
                    return false;
                }
            })
            .then(function(response) {
                if (response === false) {
                    return false;
                }
                permission =
                    response.permissions.filter(function(item) {
                        return item.permission === BRT_KEY;
                    }).length > 0;
                return permission;
            });
        return promise;
    }

    return {
        getPermission: function() {
            return BrandEnvService.getDomainCode() === DomainCode.ROGERS
                ? callRogersApi(params)
                : callFidoApi();
        }
    };
})();
